import {Approaches} from "../api/models";
import { DEFAULT_MODEL } from "./defaults";

export const webProtocols = ["https://", "http://", "ftps://", "sftp://", "ftp://", "ftpes://", "scp://"];
// export const GreetingText = " ! I am your Fonterra ChatGPT Assistant. I am trained to answer queries on Fonterra data. What would you like to know?"
export const GreetingText = " ! I am your Fonterra AI Assistant. What would you like to know?"
export const LLMModelNames = [
    { company: 'Microsoft', models: [{ model: 'azureopenai' , enabled: true}]}
];
export const AgentTypeList = [
    { key: 'openaifunctions', description: 'Open AI Functions Agent'},
    { key: 'conversationchat', description: 'Conversation Chat Agent'},
    { key: 'custom', description: 'Custom Agent'},
    { key: 'zeroshot', description: 'Zero Shot Agent' }
];

// Separate image generation configuration
export const ImageGenConfig = {
    temperature: 0.7,
    llmModelName: "azureopenai",
    gptVersion: "dall-e-3",
    version: "v3",
    tools: [{ name: "imagegen" }]
};

// Unified chat configuration that combines all text-based features
export const UnifiedConfig = {
    temperature: null, // Since frontend currently does not support changing temperature, send null for backend to fallback to default for reasoning models, or 0 for models like gpt-4o
    llmModelName: "azureopenai",
    gptVersion: DEFAULT_MODEL,
    version: "v3",
    nativeSearch: true,
    useSemanticRanker: true,
    agentType: "openaifunctions",
    // Enable all tools for unified experience
    tools: [
        { name: "websearch" },
        { name: "acs" },
        { name: "databricks" }
    ],
    approach: Approaches.ReadRetrieveRead
};

export const InputCharacterLimit: number = import.meta.env.VITE_APP_INPUT_CHAR_LIMIT || 400000;
export const Max_Interactions: number = 30;
export const Max_Upload_Files: number = 20;
export const Max_Upload_File_Size_MB: number = 300;
export const ShowPreviewFeatures: string = import.meta.env.VITE_APP_SHOW_PREVIEW_FEATURES || "false";
export const ReleaseNotesUrl: string = import.meta.env.VITE_APP_RELEASE_NOTES_URL || "";
export const FeedbackFormUrl: string = import.meta.env.VITE_APP_FEEDBACK_FORM_URL || "";
export const LearnMoreLink: string = import.meta.env.VITE_APP_LEARNMORE_LINK || "";
